import * as Types from '../../../../_generated/types';

import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
import { FieldBaseFragmentDoc, FieldCommonFragmentDoc, FieldAttributeFragmentDoc, FieldOptionFragmentDoc } from '../../gql/_generated/fieldCommon.generated';
export type FieldAddressFragment = { __typename: 'Field_Address', address1Collapsed?: boolean | null, address1DefaultValue?: string | null, address1Enabled?: boolean | null, address1ErrorMessage?: string | null, address1Hidden?: boolean | null, address1Label?: string | null, address1Placeholder?: string | null, address1PrePopulate?: string | null, address1Required?: boolean | null, address2Collapsed?: boolean | null, address2DefaultValue?: string | null, address2Enabled?: boolean | null, address2ErrorMessage?: string | null, address2Hidden?: boolean | null, address2Label?: string | null, address2Placeholder?: string | null, address2PrePopulate?: string | null, address2Required?: boolean | null, address3Collapsed?: boolean | null, address3DefaultValue?: string | null, address3Enabled?: boolean | null, address3ErrorMessage?: string | null, address3Hidden?: boolean | null, address3Label?: string | null, address3Placeholder?: string | null, address3PrePopulate?: string | null, address3Required?: boolean | null, cityCollapsed?: boolean | null, cityDefaultValue?: string | null, cityEnabled?: boolean | null, cityErrorMessage?: string | null, cityHidden?: boolean | null, cityLabel?: string | null, cityPlaceholder?: string | null, cityPrePopulate?: string | null, cityRequired?: boolean | null, countryCollapsed?: boolean | null, countryDefaultValue?: string | null, countryEnabled?: boolean | null, countryErrorMessage?: string | null, countryHidden?: boolean | null, countryLabel?: string | null, countryPlaceholder?: string | null, countryPrePopulate?: string | null, countryRequired?: boolean | null, stateCollapsed?: boolean | null, stateDefaultValue?: string | null, stateEnabled?: boolean | null, stateErrorMessage?: string | null, stateHidden?: boolean | null, stateLabel?: string | null, statePlaceholder?: string | null, statePrePopulate?: string | null, stateRequired?: boolean | null, zipCollapsed?: boolean | null, zipDefaultValue?: string | null, zipEnabled?: boolean | null, zipErrorMessage?: string | null, zipHidden?: boolean | null, zipLabel?: string | null, zipPlaceholder?: string | null, zipPrePopulate?: string | null, zipRequired?: boolean | null, defaultValue?: string | null, id?: string | null, name?: string | null, placeholder?: string | null, required?: boolean | null, labelPosition?: string | null, inputTypeName?: string | null, instructions?: string | null, handle?: string | null, errorMessage?: string | null, cssClasses?: string | null, conditions?: string | null, enableConditions?: boolean | null, countryOptions?: Array<{ __typename: 'FieldAttribute', value?: string | null, label?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null };

export const FieldAddressFragmentDoc = gql`
    fragment fieldAddress on Field_Address {
  ...fieldBase
  address1Collapsed
  address1DefaultValue
  address1Enabled
  address1ErrorMessage
  address1Hidden
  address1Label
  address1Placeholder
  address1PrePopulate
  address1Required
  address2Collapsed
  address2DefaultValue
  address2Enabled
  address2ErrorMessage
  address2Hidden
  address2Label
  address2Placeholder
  address2PrePopulate
  address2Required
  address3Collapsed
  address3DefaultValue
  address3Enabled
  address3ErrorMessage
  address3Hidden
  address3Label
  address3Placeholder
  address3PrePopulate
  address3Required
  cityCollapsed
  cityDefaultValue
  cityEnabled
  cityErrorMessage
  cityHidden
  cityLabel
  cityPlaceholder
  cityPrePopulate
  cityRequired
  countryCollapsed
  countryDefaultValue
  countryEnabled
  countryErrorMessage
  countryHidden
  countryLabel
  countryPlaceholder
  countryPrePopulate
  countryRequired
  stateCollapsed
  stateDefaultValue
  stateEnabled
  stateErrorMessage
  stateHidden
  stateLabel
  statePlaceholder
  statePrePopulate
  stateRequired
  zipCollapsed
  zipDefaultValue
  zipEnabled
  zipErrorMessage
  zipHidden
  zipLabel
  zipPlaceholder
  zipPrePopulate
  zipRequired
  countryOptions {
    ...fieldAttribute
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {

  };
}
export type Sdk = ReturnType<typeof getSdk>;